import { CONSTANTS } from '../../../utils'

function replaceUrduText(string_to_replace, regex, text_to_replace) {
	// The substituted value will be contained in the result variable
	const result = string_to_replace.replace(regex, text_to_replace)

	return result
}

function FORMAT_OTP_PLACEHOLDER(string_to_replace, network_name, phone_number) {
	const phone_number_regex = /(?=\s|)({0345 111 1111})(?=\s|$)/g
	const network_regex = /(?=\s|)({ٹیلی نار})(?=\s|$)/g

	let formatted_text = replaceUrduText(
		string_to_replace,
		phone_number_regex,
		' <span className="num" dir=' + CONSTANTS.LANG_DIRECTION.LTR + '>' + phone_number + '</span>'
	)

	formatted_text = replaceUrduText(formatted_text, network_regex, network_name)

	return formatted_text
}

function FORMAT_MAX_QUANTITY_REACH_MSG(string_to_replace, item_name) {
	const item_name_regex = /(?=\s|)({مقدار})(?=\s|$)/g
	let formatted_text = replaceUrduText(
		string_to_replace,
		item_name_regex,
		'<b>' + item_name + '</b>'
	)
	return formatted_text
}

function FORMAT_CART_ITEM_ADD_MSG(string_to_replace, item_name) {
	const item_name_regex = /(?=\s|)({آئٹم})(?=\s|$)/g
	let formatted_text = replaceUrduText(
		string_to_replace,
		item_name_regex,
		'<b>' + item_name + '</b>'
	)
	return formatted_text
}

function FORMAT_PURCHASE_TYPE_MAX_LIMIT_MSG(string_to_replace, item_name) {
	const item_name_regex = /(?=\s|)({مقدار})(?=\s|$)/g
	let formatted_text = replaceUrduText(
		string_to_replace,
		item_name_regex,
		'<b>' + item_name + '</b>'
	)
	return formatted_text
}

function FORMAT_CART_SUMMARY_MSG(string_to_replace, item_name) {
	const item_name_regex = /(?=\s|)({آئٹم})(?=\s|$)/g
	let formatted_text = replaceUrduText(string_to_replace, item_name_regex, item_name)
	return formatted_text
}

const LANG_FORMAT = {
	FORMAT_OTP_PLACEHOLDER,
	FORMAT_CART_ITEM_ADD_MSG,
	FORMAT_PURCHASE_TYPE_MAX_LIMIT_MSG,
	FORMAT_CART_SUMMARY_MSG,
	FORMAT_MAX_QUANTITY_REACH_MSG,
}
export default LANG_FORMAT
